import { Spinner } from '@syia-ai/maritimeai-ui';

/**
 * The shell's loading state: a centred Maritime Spinner. `fill="screen"` for a whole page
 * (guards, redirects); `fill="area"` inside the layout or over an iframe while it loads.
 */
export default function AppLoader({
  fill = 'screen',
  label = 'Loading',
}: {
  fill?: 'screen' | 'area' | 'overlay';
  label?: string;
}) {
  return (
    <div className={`shell-loader shell-loader--${fill}`}>
      <Spinner size="lg" label={label} />
    </div>
  );
}
